import React, {useState, useEffect} from 'react';
import CheckinViewGraph from './CheckinViewGraph';

/**
 * Le graphique des checkins
 * @param {*} props props
 * @return {JSX}
 */
export default function CheckinGraph(props) {
  const [taches, setTaches] = useState([{}]);

  useEffect(() => {
    setTaches(props.taches);
  }, []);

  const onHandleChange = (data) => {
    setTaches([...data]);
  };

  return (
    <div>
      <CheckinViewGraph data={taches} onHandleChange={onHandleChange} />
    </div>
  );
}
